const THEME_COLORS = [
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "dark",
  "light",
];

function resolveColor(color, opacity = 1) {
  if (!color) return null;
  if (THEME_COLORS.includes(color)) {
    return `rgba(var(--vs-${color}), ${opacity})`;
  }
  if (color.startsWith("#") && opacity !== 1) {
    const hex = color.replace("#", "");
    const normalized =
      hex.length === 3
        ? hex
            .split("")
            .map((character) => character + character)
            .join("")
        : hex;
    const value = parseInt(normalized, 16);
    if (!Number.isNaN(value)) {
      return `rgba(${(value >> 16) & 255},${(value >> 8) & 255},${
        value & 255
      },${opacity})`;
    }
  }
  return color;
}

function resolveContainer(container) {
  if (container instanceof Element) return container;
  if (typeof container === "string") return document.querySelector(container);
  return document.body;
}

function createEffect(type, color, index) {
  const effect = document.createElement("div");
  effect.className = `effect-${index} effects`;

  if (type === "border") {
    effect.style.borderLeft = `1px solid ${resolveColor(color)}`;
  } else if (type === "point") {
    effect.style.background = resolveColor(color, 0.4);
  } else if (type === "radius") {
    effect.style.border = `3px solid ${resolveColor(color)}`;
  } else if (type === "corners") {
    if (index === 1) effect.style.border = `3px solid ${resolveColor(color)}`;
  } else if (type === "sound") {
    effect.style.background = resolveColor(color);
  } else {
    effect.style.borderLeft = `3px solid ${resolveColor(color)}`;
  }

  return effect;
}

function createMaterialSpinner() {
  const namespace = "http://www.w3.org/2000/svg";
  const spinner = document.createElementNS(namespace, "svg");
  spinner.setAttribute("class", "spinner");
  spinner.setAttribute("width", "50px");
  spinner.setAttribute("height", "50px");
  spinner.setAttribute("viewBox", "0 0 66 66");

  const circle = document.createElementNS(namespace, "circle");
  circle.setAttribute("class", "path");
  circle.setAttribute("fill", "none");
  circle.setAttribute("stroke-width", "5");
  circle.setAttribute("stroke-linecap", "round");
  circle.setAttribute("cx", "33");
  circle.setAttribute("cy", "33");
  circle.setAttribute("r", "30");
  spinner.appendChild(circle);
  return spinner;
}

function createLoading(parameters = {}) {
  const type = parameters.type || "default";
  const color = parameters.color || "primary";
  const background = parameters.background || "rgba(255,255,255,.6)";
  const scale = parameters.scale === undefined ? 1 : parameters.scale;
  const container = resolveContainer(parameters.container);
  if (!container) return null;

  const overlay = document.createElement("div");
  overlay.className = [
    "con-vs-loading",
    `vs-loading-background-${background}`,
    `vs-loading-color-${color}`,
    parameters.textAfter ? "textAfter" : "",
  ]
    .filter(Boolean)
    .join(" ");
  overlay.style.background = resolveColor(background);

  if (parameters.text) {
    const title = document.createElement("h4");
    title.className = "title-loading";
    title.textContent = parameters.text;
    overlay.appendChild(title);
  }

  const loading = document.createElement("div");
  loading.className = `vs-loading ${type}`;
  loading.style.transform = `scale(${scale})`;

  if (type !== "material") {
    [1, 2, 3].forEach((index) => {
      loading.appendChild(createEffect(type, color, index));
    });
  }

  const image = document.createElement("img");
  image.src = parameters.src || "";
  loading.appendChild(image);
  if (type === "material") loading.appendChild(createMaterialSpinner());
  overlay.appendChild(loading);

  if (parameters.clickEffect) {
    overlay.addEventListener("click", (event) => {
      const effect = document.createElement("div");
      effect.className = "effect-click";
      effect.style.left = `${event.offsetX}px`;
      effect.style.top = `${event.offsetY}px`;
      overlay.insertBefore(effect, overlay.firstChild);
      setTimeout(() => effect.remove(), 50);
    });
  }

  container.insertBefore(overlay, container.firstChild);
  return overlay;
}

function closeLoading(target) {
  let loadings;
  if (target instanceof Element) {
    loadings = Array.from(target.children).filter((element) =>
      element.classList.contains("con-vs-loading")
    );
  } else {
    loadings = document.querySelectorAll(
      target || "body > .con-vs-loading"
    );
  }

  loadings.forEach((loading) => {
    loading.classList.add("beforeRemove");
    setTimeout(() => loading.remove(), 300);
  });
}

export function installVsLoading(app, legacyVs) {
  const vs = app.config.globalProperties.$vs || legacyVs || {};
  const loading = (parameters) => createLoading(parameters);
  loading.close = closeLoading;
  vs.loading = loading;
  app.config.globalProperties.$vs = vs;
}
